export interface RenamedCategories {
  [key: string]: string;
}

export const renamedCategories: RenamedCategories = {
  expired: 'Produk Kadaluarsa',
  spoiled: 'Produk Rusak Belum Kadaluarsa',
  'sisa preparation': 'Produk Sisa Persiapan',
  'waste ck handling': 'Produk Central Kitchen',
  operasional: 'Pembuangan Operasional',
  'cancelled orders': 'Order Batal dari Customer',
  trial: 'Pembuangan Trial'
};

export const excludedCategories = ['return to bp', 'return to hub kemang'];

export const displayedCategoryName = (wasteCategoryName: string) => {
  const lowerCasedWasteCategoryName = wasteCategoryName.toLowerCase(),
    renamedWasteCategoryName = renamedCategories[lowerCasedWasteCategoryName],
    isRenameRequired = renamedWasteCategoryName ? true : false;
  return isRenameRequired ? renamedWasteCategoryName : wasteCategoryName;
};
